// extracted by mini-css-extract-plugin
module.exports = {"ChatDealListPane":"ChatDealListPane_ChatDealListPane__ef_2o","TitleWrapper":"ChatDealListPane_TitleWrapper__5SnfX","Title":"ChatDealListPane_Title__hZwS7"};